/*
 * Variant Image Filter for Testament Theme
 * Filters product gallery to show only images for selected color variant
 */
(function() {
  'use strict';

  // Wait for DOM and theme to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initVariantImageFilter();
  });

  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-section-type="product__section"]')) {
      setTimeout(initVariantImageFilter, 100);
    }
  });

  function initVariantImageFilter() {
    // Find all product sections
    const productSections = document.querySelectorAll('[data-section-type="product__section"]');
    
    productSections.forEach(function(section) {
      setupFilterForSection(section);
    });
  }

  function setupFilterForSection(section) {
    // Get product JSON
    const productJsonEl = section.querySelector('.product-json');
    if (!productJsonEl) return;

    let product;
    try {
      product = JSON.parse(productJsonEl.innerHTML);
    } catch (e) {
      console.error('Could not parse product JSON');
      return;
    }

    // Check if product has variants and a color option
    if (!product.variants || product.variants.length <= 1) return;

    const colorOptionIndex = getColorOptionIndex(product);
    if (colorOptionIndex === -1) return;

    // Get gallery elements - Testament uses these selectors
    const mainGallery = section.querySelector('.js-carousel-main, .product__media-list');
    const thumbGallery = section.querySelector('.js-thumb-carousel-nav, .carousel-nav');
    
    if (!mainGallery) return;

    // Store original display states
    storeOriginalStates(mainGallery, thumbGallery);

    // Build the variant-to-image mapping
    const variantImageMap = buildVariantImageMap(product, colorOptionIndex);

    // Get all images that aren't assigned to any variant (lifestyle shots)
    const unassignedMediaIds = getUnassignedMediaIds(product, mainGallery);

    // Listen for variant changes using Testament's event system
    if (typeof Events !== 'undefined') {
      Events.on('variantchange:image', function(mediaId, context) {
        if (context !== section) return;
        
        // Find the variant by its featured media
        const variant = product.variants.find(v => v.featured_media && v.featured_media.id == mediaId);
        if (variant) {
          filterImages(variant, product, colorOptionIndex, variantImageMap, unassignedMediaIds, mainGallery, thumbGallery, section);
        }
      });
    }

    // Also listen for swatch/selector changes directly
    const variantSelectors = section.querySelectorAll('.js-variant-selector, .single-option-selector, [data-option-input]');
    variantSelectors.forEach(function(selector) {
      selector.addEventListener('change', function() {
        setTimeout(function() {
          const currentVariant = getCurrentVariant(section, product);
          if (currentVariant) {
            filterImages(currentVariant, product, colorOptionIndex, variantImageMap, unassignedMediaIds, mainGallery, thumbGallery, section);
          }
        }, 50);
      });
    });

    // Listen for swatch clicks
    const swatches = section.querySelectorAll('.swatches__form--input, [type="radio"][data-position]');
    swatches.forEach(function(swatch) {
      swatch.addEventListener('change', function() {
        setTimeout(function() {
          const currentVariant = getCurrentVariant(section, product);
          if (currentVariant) {
            filterImages(currentVariant, product, colorOptionIndex, variantImageMap, unassignedMediaIds, mainGallery, thumbGallery, section);
          }
        }, 50);
      });
    });

    // Initial filter on page load
    const initialVariant = getInitialVariant(section, product);
    if (initialVariant) {
      setTimeout(function() {
        filterImages(initialVariant, product, colorOptionIndex, variantImageMap, unassignedMediaIds, mainGallery, thumbGallery, section);
      }, 100);
    }
  }

  function getColorOptionIndex(product) {
    const colorNames = ['color', 'colour', 'farbe', 'couleur', 'colore', 'kleur', 'цвет', 'färg'];
    for (let i = 0; i < product.options.length; i++) {
      if (colorNames.includes(product.options[i].toLowerCase())) {
        return i;
      }
    }
    return -1;
  }

  function storeOriginalStates(mainGallery, thumbGallery) {
    const allItems = mainGallery.querySelectorAll('.carousel-cell, .product-media-container, .js-product-image-item, [data-media-id]');
    allItems.forEach(function(item) {
      item.setAttribute('data-original-display', item.style.display || '');
    });

    if (thumbGallery) {
      const thumbItems = thumbGallery.querySelectorAll('.carousel-cell, .js-thumb-item, [data-image-id]');
      thumbItems.forEach(function(item) {
        item.setAttribute('data-original-display', item.style.display || '');
      });
    }
  }

  function buildVariantImageMap(product, colorOptionIndex) {
    const map = {};
    
    product.variants.forEach(function(variant) {
      const colorValue = variant.options[colorOptionIndex];
      
      if (!map[colorValue]) {
        map[colorValue] = new Set();
      }
      
      if (variant.featured_media) {
        map[colorValue].add(variant.featured_media.id);
      }
    });

    return map;
  }

  function getUnassignedMediaIds(product, mainGallery) {
    // Get all media IDs that are assigned to variants
    const assignedIds = new Set();
    product.variants.forEach(function(variant) {
      if (variant.featured_media) {
        assignedIds.add(variant.featured_media.id);
      }
    });

    // Get all media IDs in the gallery
    const unassigned = new Set();
    const items = mainGallery.querySelectorAll('[data-image-id], [data-media-id], [data-thumbnail-id]');
    
    items.forEach(function(item) {
      let mediaId = item.getAttribute('data-image-id') || 
                    item.getAttribute('data-media-id') ||
                    extractMediaId(item.getAttribute('data-thumbnail-id'));
      
      if (mediaId && !assignedIds.has(parseInt(mediaId))) {
        unassigned.add(parseInt(mediaId));
      }
    });

    return unassigned;
  }

  function extractMediaId(thumbnailId) {
    if (!thumbnailId) return null;
    // Testament uses format like "product-template-12345"
    const match = thumbnailId.match(/(\d+)$/);
    return match ? match[1] : null;
  }

  function getCurrentVariant(section, product) {
    // Try to get from URL first
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      return product.variants.find(v => v.id == variantId);
    }

    // Try to get from form
    const variantInput = section.querySelector('input[name="id"], select[name="id"]');
    if (variantInput && variantInput.value) {
      return product.variants.find(v => v.id == variantInput.value);
    }

    // Build from selected options
    const options = [];
    
    // Check for swatches
    const swatches = section.querySelectorAll('.js-variant-selector');
    if (swatches.length > 0) {
      swatches.forEach(function(swatch) {
        const checked = swatch.querySelector('input:checked');
        if (checked) {
          options.push(checked.value);
        }
      });
    }

    // Check for selects
    const selects = section.querySelectorAll('select.js-variant-selector, select.single-option-selector');
    if (selects.length > 0 && options.length === 0) {
      selects.forEach(function(select) {
        options.push(select.value);
      });
    }

    if (options.length > 0) {
      return product.variants.find(function(variant) {
        return variant.options.every(function(option, index) {
          return options[index] === option;
        });
      });
    }

    return product.variants[0];
  }

  function getInitialVariant(section, product) {
    const initialVariantId = section.getAttribute('data-initial-variant');
    if (initialVariantId) {
      return product.variants.find(v => v.id == initialVariantId);
    }
    return getCurrentVariant(section, product);
  }

  function filterImages(variant, product, colorOptionIndex, variantImageMap, unassignedMediaIds, mainGallery, thumbGallery, section) {
    if (!variant) return;

    const currentColor = variant.options[colorOptionIndex];
    const matchingMediaIds = variantImageMap[currentColor] || new Set();

    // Filter main gallery items
    const mainItems = mainGallery.querySelectorAll('.carousel-cell, .product-media-container, .js-product-image-item, [data-media-id], [data-image-id]');
    
    mainItems.forEach(function(item) {
      const mediaId = getMediaIdFromElement(item);
      
      if (!mediaId) {
        // If we can't determine the media ID, show the item
        showElement(item);
        return;
      }

      const numericId = parseInt(mediaId);
      const shouldShow = matchingMediaIds.has(numericId) || unassignedMediaIds.has(numericId);

      if (shouldShow) {
        showElement(item);
      } else {
        hideElement(item);
      }
    });

    // Filter thumbnail gallery
    if (thumbGallery) {
      const thumbItems = thumbGallery.querySelectorAll('.carousel-cell, .js-thumb-item, [data-image-id]');
      
      thumbItems.forEach(function(item) {
        const mediaId = getMediaIdFromElement(item);
        
        if (!mediaId) {
          showElement(item);
          return;
        }

        const numericId = parseInt(mediaId);
        const shouldShow = matchingMediaIds.has(numericId) || unassignedMediaIds.has(numericId);

        if (shouldShow) {
          showElement(item);
        } else {
          hideElement(item);
        }
      });
    }

    // Refresh Flickity if it's being used
    refreshFlickity(mainGallery);
    if (thumbGallery) {
      refreshFlickity(thumbGallery);
    }
  }

  function getMediaIdFromElement(element) {
    // Try various attributes Testament might use
    let mediaId = element.getAttribute('data-image-id') ||
                  element.getAttribute('data-media-id');
    
    if (!mediaId) {
      const thumbnailId = element.getAttribute('data-thumbnail-id');
      if (thumbnailId) {
        mediaId = extractMediaId(thumbnailId);
      }
    }

    // Check for nested elements with media IDs
    if (!mediaId) {
      const nested = element.querySelector('[data-image-id], [data-media-id]');
      if (nested) {
        mediaId = nested.getAttribute('data-image-id') || nested.getAttribute('data-media-id');
      }
    }

    return mediaId;
  }

  function showElement(element) {
    element.style.display = element.getAttribute('data-original-display') || '';
    element.classList.remove('variant-image-hidden');
    element.removeAttribute('hidden');
  }

  function hideElement(element) {
    element.style.display = 'none';
    element.classList.add('variant-image-hidden');
  }

  function refreshFlickity(gallery) {
    if (typeof Flickity === 'undefined') return;
    
    const flkty = Flickity.data(gallery);
    if (flkty) {
      // Reposition cells after filtering
      setTimeout(function() {
        flkty.reloadCells();
        flkty.resize();
        flkty.select(0);
      }, 50);
    }
  }

})();